<template>
  <v-dialog
    v-model="show"
    persistent
    transition="dialog-bottom-transition"
    content-class="consumos-wrapper"
  >
    <v-card class="mb-0">
      <v-toolbar class="mt-12" dark color="primary">
        <v-btn icon dark @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ tituloToolbar }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="wrapper">
        <!-- Date picker Vuetify: solo visible en Contexto_Libre (fechaLibre != null) -->
        <div v-if="fechaLibre != null" class="fecha-libre-picker">
          <v-menu
            v-model="menuFechaLibre"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="formatFechaLibre(fechaLibreActiva)"
                label="Fecha del día"
                prepend-icon="mdi-calendar"
                readonly
                outlined
                dense
                hide-details
                class="mb-2"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="fechaLibreActiva"
              locale="es-ar"
              :first-day-of-week="1"
              @input="menuFechaLibre = false"
            ></v-date-picker>
          </v-menu>
        </div>
        <Consumos
          v-if="
            visible &&
            (idTurno > 0 ||
              idInscripcion > 0 ||
              idTorneo > 0 ||
              fechaLibreActiva != null)
          "
          ref="consumos"
          :idTurno="idTurno"
          :idInscripcion="idInscripcion"
          :idTorneo="idTorneo"
          :nombrePaciente="nombrePaciente"
          :cantJugadores="cantJugadores"
          :listaCobros="listaCobrosRef"
          :tipoTurno="tipoTurno"
          :fechaLibre="fechaLibreActiva"
          :fechaTurno="fechaTurno"
          @actualizarTotal="actualizarTotalConsumido"
          @seleccionarConsumo="onSeleccionarConsumo"
          @cobrarGrupo="onCobrarGrupo"
          @consumoBorrado="onConsumoBorrado"
        />
        <NuevoCobro
          v-if="visible"
          :idTurno="idTurno"
          :idInscripcion="idInscripcion"
          :idTorneo="idTorneo"
          :estadoTurno="estadoTurno"
          :pacienteTurno="pacienteTurno"
          :idProfesional="idProfesional"
          :idPacienteTurno="idPacienteTurno"
          :celular="celular"
          :nombrePaciente="nombrePaciente"
          :idConsumo="idConsumoSeleccionado"
          :descripcionConsumo="descripcionConsumoSeleccionado"
          :fechaLibre="fechaLibreActiva"
          :fechaTurno="fechaTurno"
          :idGrupo="idGrupoSeleccionado"
          :descripcionGrupo="nombreGrupoSeleccionado"
          @recargarLista="$emit('recargarLista')"
          @actualizarTotal="actualizarTotalPagado"
          @actualizarCobros="listaCobrosRef = $event"
          @cobroGuardado="onCobroGuardado"
          @limpiarConsumo="
            idConsumoSeleccionado = null;
            descripcionConsumoSeleccionado = null;
            idGrupoSeleccionado = null;
            nombreGrupoSeleccionado = null;
          "
          ref="nuevoCobro"
        />
        <div class="importes">
          <v-row class="mt-4 ml-1">
            <v-col cols="12" class="d-flex flex-wrap mt-auto importes-col">
              <div class="importe consumido">
                Total importe consumido: ${{ totalConsumido }}
              </div>
              <div class="importe pagado">
                Total importe pagado: ${{ totalPagado }}
              </div>
              <div class="importe saldo">Total saldo: {{ saldo }}</div>
              <v-text-field
                v-model="cantJugadores"
                label="Cant. Jugadores"
                outlined
                maxlength="2"
                class="cantidad-jugadores"
              ></v-text-field>
              <div class="importe division">
                Total por jugador: {{ toFixed(totalConsumido / cantJugadores) }}
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <v-card-actions class="mt-2">
        <v-btn
          v-if="getSaldoNumerico() > 0 && idTorneo === 0 && fechaLibre === null"
          color="purple"
          dark
          @click.stop="abrirEnviarCuentaCorriente"
        >
          <v-icon left>mdi-bank-transfer</v-icon>
          Enviar Saldo a Cuenta Corriente
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn text color="grey lighten-1" @click.stop="show = false"
          >Salir</v-btn
        >
      </v-card-actions>
    </v-card>
    <EnviarACuentaCorriente
      :visible="showEnviarCuentaCorriente"
      :saldoDisponible="getSaldoNumerico()"
      :idTurno="idTurno"
      :idInscripcion="idInscripcion"
      :idTorneo="idTorneo"
      @close="cierraEnviarCuentaCorriente"
      @enviado="handleEnviado"
    ></EnviarACuentaCorriente>
  </v-dialog>
</template>
<script>
import Consumos from "./Consumos.vue";
import NuevoCobro from "./NuevoCobro.vue";
import EnviarACuentaCorriente from "./EnviarACuentaCorriente.vue";

export default {
  props: {
    visible: {
      required: false,
    },
    idTurno: {
      required: false,
      default: 0,
    },
    idTorneo: {
      required: false,
      default: 0,
    },
    idTorneo: {
      required: false,
      default: 0,
    },
    idInscripcion: {
      required: false,
      default: 0,
    },
    pacienteTurno: { required: false },
    idProfesional: { required: false },
    idPacienteTurno: { required: false },
    tipoMovimiento: { required: false, default: "cobro" },
    estadoTurno: { required: false, default: 0 },
    celular: { type: String, required: false, default: "" },
    nombrePaciente: { type: String, required: false, default: "" },
    tipoTurno: { type: Object, required: false, default: null },
    fechaLibre: { type: String, default: null },
    fechaTurno: { type: String, default: null },
  },
  data() {
    return {
      delta: false,
      cantJugadores: null,
      totalConsumido: "0.00",
      totalPagado: "0.00",
      showEnviarCuentaCorriente: false,
      listaCobrosRef: [],
      idConsumoSeleccionado: null,
      descripcionConsumoSeleccionado: null,
      fechaLibreActiva: null,
      menuFechaLibre: false,
      idGrupoSeleccionado: null,
      nombreGrupoSeleccionado: null,
    };
  },
  computed: {
    show: {
      get() {
        if (this.visible) {
          this.cantJugadores = this.idTorneo > 0 ? 1 : this.idTurno > 0 ? 4 : 1;
        }
        return this.visible;
      },
      set(value) {
        if (!value) {
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.fechaLibreActiva = null;
          this.idConsumoSeleccionado = null;
          this.descripcionConsumoSeleccionado = null;
          this.idGrupoSeleccionado = null;
          this.nombreGrupoSeleccionado = null;
          this.$emit("close", this.delta);
        }
      },
    },
    tituloToolbar() {
      if (this.idTorneo > 0) return "Caja del Torneo";
      if (this.fechaLibre != null)
        return (
          "Caja del día — " +
          this.formatFechaLibre(this.fechaLibreActiva || this.fechaLibre)
        );
      return "Consumos y Cobros";
    },
    saldo() {
      return this.toFixed(this.totalConsumido - this.totalPagado);
    },
  },
  watch: {
    // Inicializar fechaLibreActiva cuando el modal se abre
    visible(val) {
      if (val) {
        this.cantJugadores = this.idTorneo > 0 ? 1 : this.idTurno > 0 ? 4 : 1;
        if (this.fechaLibre !== null) {
          this.fechaLibreActiva = this.fechaLibre;
        }
      }
    },
    // Actualizar si la prop fechaLibre cambia mientras el modal está abierto
    fechaLibre(val) {
      if (val !== null) {
        this.fechaLibreActiva = val;
      }
    },
    // Resetear totales al cambiar de día en caja libre
    fechaLibreActiva() {
      this.totalPagado = "0.00";
      this.listaCobrosRef = [];
    },
  },
  methods: {
    formatFechaLibre(fecha) {
      if (!fecha) return "";
      const [y, m, d] = fecha.split("-");
      return `${d}/${m}/${y}`;
    },
    toFixed(resultado) {
      if (isNaN(resultado)) return `$ ${parseFloat(0).toFixed(2)}`;
      return `$ ${parseFloat(resultado).toFixed(2)}`;
    },
    getSaldoNumerico() {
      const saldo =
        parseFloat(this.totalConsumido) - parseFloat(this.totalPagado);
      return isNaN(saldo) ? 0 : saldo;
    },
    abrirEnviarCuentaCorriente() {
      this.showEnviarCuentaCorriente = true;
    },
    cierraEnviarCuentaCorriente() {
      this.showEnviarCuentaCorriente = false;
    },
    handleEnviado() {
      this.showEnviarCuentaCorriente = false;
      this.delta = true;
      // Recargar los totales
      this.$emit("recargarLista");
      // Recargar la tabla de cobros en el componente NuevoCobro
      if (this.$refs.nuevoCobro) {
        this.$refs.nuevoCobro.buscarCobrosTurno();
      }
    },
    onCobroGuardado() {
      // Refrescar la tabla de consumos para actualizar totalPagado y saldo
      if (this.$refs.consumos) {
        this.$refs.consumos.buscarConsumosTurno();
      }
      // Refrescar cobros del consumo expandido
      if (this.$refs.consumos && this.idConsumoSeleccionado) {
        this.$refs.consumos.buscarCobrosPorConsumo(this.idConsumoSeleccionado);
      }
      // Refrescar cobros del grupo si se cobró un grupo
      if (this.$refs.consumos && this.idGrupoSeleccionado) {
        this.$refs.consumos.buscarCobrosGrupo(this.idGrupoSeleccionado);
      }
      // Refrescar lista de cobros en NuevoCobro para actualizar el total pagado
      if (this.$refs.nuevoCobro) {
        this.$refs.nuevoCobro.buscarCobrosTurno();
      }
    },
    onSeleccionarConsumo({ idConsumo, descripcion }) {
      this.idConsumoSeleccionado = idConsumo;
      this.descripcionConsumoSeleccionado = descripcion;
      // Al seleccionar un consumo, limpiar el grupo seleccionado
      this.idGrupoSeleccionado = null;
      this.nombreGrupoSeleccionado = null;
    },
    onCobrarGrupo({ idGrupo, nombreGrupo }) {
      this.idGrupoSeleccionado = idGrupo;
      this.nombreGrupoSeleccionado = nombreGrupo;
      // Limpiar consumo seleccionado
      this.idConsumoSeleccionado = null;
      this.descripcionConsumoSeleccionado = null;
    },
    onConsumoBorrado() {
      // Refresh cobros list since backend also deletes related Cobros
      if (this.$refs.nuevoCobro) {
        this.$refs.nuevoCobro.buscarCobrosTurno();
      }
    },
    actualizarTotalConsumido(total) {
      this.totalConsumido = total;
    },
    actualizarTotalPagado(total) {
      this.totalPagado = total;
    },
  },
  components: {
    Consumos,
    NuevoCobro,
    EnviarACuentaCorriente,
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: "smooth" });
    if (this.fechaLibre !== null) {
      this.fechaLibreActiva = this.fechaLibre;
    }
  },
};
</script>
<style lang="scss" scoped>
.fecha-libre-picker {
  grid-column: span 2;
  padding: 8px 8px 0;
  max-width: 220px;
  margin-top: 1rem;
}

.wrapper {
  display: grid;
  grid-template-columns: 50fr 50fr;
  padding: 0 !important;
  gap: 8px;
}

.importes {
  grid-column: span 2;
  width: 80%;

  :deep(.cantidad-jugadores) {
    flex: 0 1 170px;
    max-height: 50px;
  }

  :deep(.v-input__slot) {
    min-height: 50px;
  }
  .importes-col {
    gap: 1rem;
  }
}

/* Responsive */
@media (max-width: 1000px) {
  .wrapper {
    grid-template-columns: 1fr;
  }

  .importes {
    grid-column: auto; /* o span 1 */
    width: 100%;
    .importe {
      height: fit-content;
    }
  }
}
.importe {
  padding: 12px 6px;
  border-radius: 5px;
  color: white;
  height: 50px;
}
.consumido {
  border: 2px solid rgb(4, 99, 4);
  background: rgb(4, 121, 4);
}
.pagado {
  border: 2px solid rgb(0, 0, 121);
  background: rgb(3, 3, 230);
}
.saldo {
  border: 2px solid rgb(90, 2, 2);
  background: rgb(179, 5, 5);
}
.division {
  border: 2px solid rgb(44, 1, 75);
  background: indigo;
}
</style>
<style lang="scss">
.consumos-wrapper {
  box-shadow: none !important;
}
</style>
